import { render, staticRenderFns } from "./Exercise3-1.vue?vue&type=template&id=5dd140b4&"
import script from "./Exercise3-1.vue?vue&type=script&lang=js&"
export * from "./Exercise3-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports